const Home = () => {

    return (
        <div>
             <h1>
                Welcome to WorkID
            </h1>

            <p>Your work decentralized identity and proof of experience</p>
        </div>
    )
}

export default Home